import React, { useEffect, useState } from 'react'
import { Col, Row } from "antd";
import WidgetIntegracaoAditivo from './WidgetIntegracaoAditivo';
import WidgetAditivo from './WidgetAditivo';
import { GetAbaAditivo } from '@app/api/sas/ordemCompra';
import { useRecoilState, useRecoilValue } from 'recoil';
import { dadosGeraisState, ordemCompraIdState, reloadState } from '../atoms';
import WidgetHistoricoAprovacoes from '../AbaIntegracaoContrato/WidgetHistoricoAprovacoes';
import { Visibility } from '@app/components';
interface Props {
  ehComprador?: boolean;
}
const AbaAditivos = ({ ehComprador = false }: Props) => {
    const [hasIncluded,setHasIncluded]= useState(false);
    const [data, setData] = useState<any>();
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [valorTotal, SetValorTotal] = useState<number | undefined>();
    const [dataInicial, setDataInicial] = useState<Date | undefined>();
    const [dataFinal, setDataFinal] = useState<Date | undefined>();
    const [reload, setReload] = useRecoilState(reloadState);
    const dadosGerais = useRecoilValue(dadosGeraisState);

    useEffect(() => {
        if (ordemCompraId) {
            GetAbaAditivo(ordemCompraId).then((data: any) => {
                if (data) {
                    if (!data.modalidadeContrato) {
                        data.modalidadeContrato = 1;
                        data.tipoControleContrato = 1;
                        data.unidadeMedicao = 1;
                        data.caracteristicaItem = 1;
                        data.controlePrecoQtde = 1;
                    }else{
                        setHasIncluded(true);
                    }

                    SetValorTotal(data.valorTotal);
                    setData(data);
                    setDataFinal(data.dataFinal);
                    setDataInicial(data.dataInicio);
                }
            });
        }
    }, [ordemCompraId, reload]);

    return (
        <Row>
            <Col>
                <WidgetIntegracaoAditivo
                    hasIncluded={hasIncluded}
                    ordemCompraId={ordemCompraId}
                    dataFinal={dataFinal}
                    dataInicial={dataInicial}
                    setDataInicial={setDataInicial}
                    setDataFinal={setDataFinal}
                    valorTotal={valorTotal}
                    data={data}
                />
                <WidgetAditivo
                    valorTotal={valorTotal}
                    data={data}    
                    ehComprador={ehComprador}                
                />
                <Visibility visible={dadosGerais.isPrazo || dadosGerais.isValorSemAcrescimoEscopo}>
                    <WidgetHistoricoAprovacoes />
                </Visibility>
            </Col>
        </Row>
    )
}

export default AbaAditivos